<ub-card [rounded]="true">
  <h3 class="t-upper t-weight--normal" title>
    {{ title }}
  </h3>
  <div actions>
    <button mat-button color="primary" type="button" (click)="selectWalkthroughs()">
      <mat-icon aria-label="settings" i18n-aria-label>settings</mat-icon>
    </button>
  </div>
  <div content *ngIf="(walkthroughs$ | async) as walkthroughs; else loadingTemplate">
    <div class="walkthrough" *ngFor="let walkthrough of walkthroughs">
      <h2>
        {{ walkthrough.title }}
      </h2>
      <div class="steps">
        <ub-stepper [steps]="ubSteps[walkthrough.orig._id]" [condensed]="true"></ub-stepper>
      </div>
    </div>
    <div *ngIf="walkthroughs.length === 0">
      <p i18n>
        No walkthroughs found.
      </p>
    </div>
  </div>
  <div footer>
    <span *ngIf="lastUpdated$ | async; let lastUpdated; else selectTemplate">
      <ng-container i18n>Last updated</ng-container>: {{ lastUpdated | date:'medium'}}
      <button mat-flat-button type="button" color="primary" (click)="onRefresh()" i18n>Refresh</button>
    </span>
  </div>
</ub-card>
<ng-template #selectTemplate>
    <span *ngIf="(allWalkthroughs$ | async)?.length">
      <button mat-flat-button
              color="primary"
              type="button"
              (click)="selectWalkthroughs()" i18n>Select active walkthroughs</button>
    </span>
</ng-template>

<ng-template #loadingTemplate>
  <div content>
    <p i18n>Loading your walkthroughs, please wait.</p>
  </div>
</ng-template>
